import {
  additionalCostDefinitions,
  dynamicAdditionalCostDefinitions,
  dynamicLocationDefinitions,
  exactCombitDefaults,
} from "./CombitTextDefinitions";

const normalize = (value) => String(value)
  .normalize("NFC")
  .replace(/\u00a0/g, " ")
  .replace(/\s+/g, " ")
  .trim();

const equalsAlias = (value, aliases) => aliases.some(
  (alias) => normalize(alias).toLocaleLowerCase("de-DE") === value.toLocaleLowerCase("de-DE"),
);

export const classifyAdditionalCost = (description) => {
  const value = normalize(description);
  const fixed = additionalCostDefinitions.find((definition) => equalsAlias(value, definition.aliases));
  if (fixed) return { key: fixed.key, translationKey: fixed.translationKey, params: {} };

  for (const definition of dynamicAdditionalCostDefinitions) {
    for (const pattern of definition.patterns) {
      const match = value.match(pattern);
      if (match) {
        return {
          key: definition.key,
          translationKey: definition.translationKey,
          params: definition.params ? definition.params(match) : {},
        };
      }
    }
  }
  return null;
};

export const localizeAdditionalCost = (description, translate) => {
  const classification = classifyAdditionalCost(description);
  return classification && classification.translationKey
    ? translate(classification.translationKey, classification.params)
    : description;
};

export const localizeKnownCombitText = (field, value, translate) => {
  if (typeof value !== "string") return value;
  const normalized = normalize(value);
  const fixed = (exactCombitDefaults[field] || []).find((definition) => equalsAlias(normalized, definition.aliases));
  if (fixed) return translate(fixed.translationKey);

  if (field === "location") {
    for (const definition of dynamicLocationDefinitions) {
      const match = normalized.match(definition.pattern);
      if (match) return translate(definition.translationKey, definition.params(match));
    }
  }
  return value;
};
